export default __webpack_public_path__ + "static/media/mockupwebapp4.adb7379d.jpg";